import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { getEnvVariables } from '../../helpers/getEnvVariables';
const { REACT_APP_URL } = getEnvVariables();

export const bannersApi = createApi({
    reducerPath: 'banners',
    baseQuery: fetchBaseQuery({ baseUrl: REACT_APP_URL }),
    endpoints: (builder) => ({
        getBanners: builder.query({
            query: () => 'banners',
            keepUnusedDataFor: 600,
        }),
    }),
});

export const { useGetBannersQuery } = bannersApi;